'use strict';

/**
 * Get container that holds select + qty-error for both PDP (.qty-wrapper) and bonus modal (no qty-wrapper)
 * @param {jQuery} $input - The quantity input element
 * @returns {jQuery} The container element
 */
function getQuantityContainer($input) {
    return $input.closest('.qty-input-block').parent();
}

/**
 * Quantity +/- functionality
 * Uses event delegation so handlers work for dynamically loaded content (e.g. bonus product modal)
 */
$(document).on('click keydown', '.qty-minus, .qty-plus', function (e) {
    if (e.type === 'keydown' && (e.key !== 'Enter' && e.key !== ' ')) {
        return true;
    }
    e.stopPropagation();
    e.stopImmediatePropagation();
    var $input = $(this).parent().find('input');
    var min = $input.attr('min');
    var max = $input.attr('max');
    var count;
    if ($(this).hasClass('qty-minus')) {
        count = parseInt($input.val(), 10) - 1;
    } else {
        count = (parseInt($input.val(), 10) + 1);
    }
    if (count >= min && count <= max) {
        $input.val(count);
        $input.attr('aria-invalid', 'false');
        $input.change();
    } else if (count > max) {
        var maxError;
        if ($input.attr('data-one-qty-product') === 'true') {
            maxError = $input.attr('data-one-qty-error');
        } else {
            maxError = $input.attr('data-max-error');
        }
        getQuantityContainer($input).find('.qty-error').text(maxError);
        $input.attr('aria-invalid', 'true');
        $input.focus();
    } else {
        var minError = $input.attr('data-min-error');
        getQuantityContainer($input).find('.qty-error').text(minError);
        $input.attr('aria-invalid', 'true');
        $input.focus();
    }
    return false;
});

$(document).on('change', '.qty-input', function () {
    var $input = $(this);
    var $container = getQuantityContainer($input);
    $container.find('.qty-error').empty().removeClass('has-range-error');
    var value = parseInt($input.val(), 10);
    var min = parseInt($input.attr('min'), 10);
    var max = parseInt($input.attr('max'), 10);
    var $select = $container.find('select');
    $select.val(value);
    // In bonus modal, only sync value - do NOT trigger select.change() (avoids attributeSelect/spinner)
    // When value exceeds max (or is below min), skip select.change() to avoid AJAX with invalid quantity (null error)
    var inRange = Number.isNaN(min) || Number.isNaN(max) || (value >= min && value <= max);
    if ($container.closest('#chooseBonusProductModal').length === 0 && inRange) {
        $select.change();
    }
});

$(document).on('blur', '.qty-input', function () {
    var $input = $(this);
    var $container = getQuantityContainer($input);
    var min = $input.attr('min');
    var max = $input.attr('max');
    var value = parseInt($input.val(), 10);
    var $select = $container.find('select');
    var currentSelectVal = parseInt($select.val(), 10);

    // Only trigger 'change' if the value is actually different
    if (value !== currentSelectVal) {
        $input.val(value).trigger('change');
    }

    if (value === '' || Number.isNaN(Number(value))) {
        $input.closest('.product-detail').find('.add-to-cart').attr('disabled', true).addClass('disabled');
    } else if (value < min || value > max) {
        
        var qtyError;
        if ($input.attr('data-one-qty-product') === 'true' && value > max) {
            qtyError = $input.attr('data-one-qty-error');
        } else {
            qtyError = $input.attr('data-range-error');
        }
        $container.find('.qty-error').empty().append(qtyError).addClass('has-range-error');
        $input.closest('.product-detail').find('.add-to-cart').attr('disabled', true).addClass('disabled');
    } else if ($('.availability-and-promo').find('.availability').data('available') === true && $('.availability-and-promo').find('.availability').data('ready-to-order') === true) {
        $container.find('.qty-error').empty().removeClass('has-range-error');
        $input.closest('.product-detail').find('.add-to-cart').removeAttr('disabled').removeClass('disabled');
    }
});
